import { ApiError, isApiError } from "@core/api/api-error";
import { isAxiosError } from "@core/api/interceptors/axios-error";
import { Interceptor } from "@core/api/interceptors/interceptor";
import { ErrorManager } from "@core/error-manager";
import { AxiosResponse } from "axios";

export const errorHandlingInterceptor: (errorManager?: ErrorManager) => Interceptor<AxiosResponse> = (
	errorManager?: ErrorManager,
) => ({
	onRejected: error => {
		if (isAxiosError(error) && error.response) {
			if (error.response.data && isApiError(error.response.data)) {
				errorManager?.handleCustomApiError(error.response.data);
				const apiError = Object.assign(new Error("ApiError"), error.response.data);
				return Promise.reject(apiError);
			}
			const data: ApiError = {
				path: "unknown",
				status: error.response.status,
			};
			const apiError = Object.assign(new Error("ApiError"), data);
			return Promise.reject(apiError);
		}
		return Promise.reject(error);
	},
});
